import { useEffect, useState } from 'react';

const UNREAD_THREADS_CHANGED_EVENT = 'opal::threads::unreadChanged';

/**
 * Hook to track unread threads indicator state from chat-frontend.
 * Listens for custom events dispatched by chat-frontend.
 */
export function useUnreadThread() {
  const [hasUnreadThreads, setHasUnreadThreads] = useState(false);

  useEffect(() => {
    // Listen for custom event from chat-frontend
    const handleUnreadChanged = (event: CustomEvent<{ hasUnreadThreads: boolean }>) => {
      setHasUnreadThreads(event.detail?.hasUnreadThreads ?? false);
    };

    document.addEventListener(UNREAD_THREADS_CHANGED_EVENT, handleUnreadChanged as EventListener);

    return () => {
      document.removeEventListener(
        UNREAD_THREADS_CHANGED_EVENT,
        handleUnreadChanged as EventListener
      );
    };
  }, []);

  return { hasUnreadThreads };
}
